
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';
import { clientQuery } from 'Core/data/GraphQLApi';

//```import constants types
import {
    VIDFLEET_DMS_STATUS_REQUEST
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import {
    dmsStatusResult
} from 'Redux/actions';


function* dmsStatus({ payload }) {
    try {
        const { filters } = payload;
        let startDate = filters.startDate
        let endDate = filters.endDate
        let count = +filters.limit;
        let from = +filters.from;
        let hasMore = filters.hasMore;

        let QUERY = `
            query getDMSStatusChange($esn: String, $from: Int!, $count: Int!, $dateRange: AWSDateTimeRange){
                result: getDMSStatusChange(esn: $esn, from: $from, count: $count, dateRange: $dateRange)
            }
        `

        let dateRange = null

        if (filters?.filterByDate) {
            dateRange = {
                start: startDate,
                end: endDate
            }
        }

        let data = yield call(
            clientQuery,
            QUERY,
            {
                esn: filters.esn || null,
                from: from,
                count: count,
                dateRange: dateRange
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let result = JSON.parse(data?.result)
            yield put(dmsStatusResult({ result, error: null, hasMore }));
        }else {
            yield put(dmsStatusResult({ result: {dmsStatusChanges: []}, error: null, hasMore }));
        }

    } catch (exc) {
        yield put(dmsStatusResult({ error: true, errorCode: exc.request?.status }));
        ExceptionManager(
            exc,
            "Modules/vidFleet/components/dmsStatuses/redux/saga",
            "dmsStatusesList"
        )
    }
}

function* watchMethods() {
    yield takeEvery(VIDFLEET_DMS_STATUS_REQUEST, dmsStatus);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}